import { render } from "./CardControl.vue?vue&type=template&id=70aeca54&scoped=true"
import script from "./CardControl.vue?vue&type=script&lang=js"
export * from "./CardControl.vue?vue&type=script&lang=js"

import "./CardControl.vue?vue&type=style&index=0&id=70aeca54&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70aeca54"]])

export default __exports__